// src/Reports.jsx
import React, { useState, useEffect } from "react";
import api from "./api";
import * as XLSX from "xlsx";

const Reports = () => {
  const [products, setProducts] = useState([]);
  const [stmList, setStmList] = useState([]);
  const [selectedDays, setSelectedDays] = useState("7");
  const [selectedStm, setSelectedStm] = useState("");

  useEffect(() => {
    api.get("/products", { withCredentials: true })
      .then(res => {
        setProducts(res.data);
        const uniqueStm = [...new Set(res.data.map(p => p.location).filter(Boolean))];
        setStmList(uniqueStm);
      })
      .catch(() => alert("❌ Błąd ładowania produktów"));
  }, []);

  const exportToExcel = (data, fileName) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Produkty");
    XLSX.writeFile(workbook, fileName);
  };

  const handleExportAll = () => {
    const exportData = products.map(({ images, ...rest }) => rest);
    exportToExcel(exportData, "wszystkie_produkty.xlsx");
  };

  const handleExportByDays = () => {
    const days = parseInt(selectedDays, 10);
    const cutoff = new Date();
    cutoff.setDate(cutoff.getDate() - days);
    const filtered = products.filter(p => new Date(p.created_at) >= cutoff);
    exportToExcel(filtered.map(({ images, ...rest }) => rest), `produkty_ostatnie_${days}_dni.xlsx`);
  };

  const handleExportBySTM = () => {
    const filtered = products.filter(p => p.location === selectedStm);
    exportToExcel(filtered.map(({ images, ...rest }) => rest), `produkty_stm_${selectedStm}.xlsx`);
  };

  return (
    <div className="container py-4">
      <h2 className="mb-4">📑 Raporty</h2>

      <div className="mb-4">
        <h5>1. Eksport wszystkich produktów (bez zdjęć)</h5>
        <button className="btn btn-outline-primary" onClick={handleExportAll}>
          📥 Eksportuj do Excela
        </button>
      </div>

      <div className="mb-4">
        <h5>2. Eksport produktów z ostatnich dni</h5>
        <select
          className="form-select w-auto d-inline-block me-2"
          value={selectedDays}
          onChange={(e) => setSelectedDays(e.target.value)}
        >
          <option value="1">Ostatni 1 dzień</option>
          <option value="7">Ostatnie 7 dni</option>
          <option value="30">Ostatnie 30 dni</option>
        </select>
        <button className="btn btn-outline-primary" onClick={handleExportByDays}>
          📥 Eksportuj
        </button>
      </div>

      <div className="mb-4">
        <h5>3. Eksport produktów z wybraną wartością STM</h5>
        <select
          className="form-select w-auto d-inline-block me-2"
          value={selectedStm}
          onChange={(e) => setSelectedStm(e.target.value)}
        >
          <option value="">-- wybierz STM --</option>
          {stmList.map((stm) => (
            <option key={stm} value={stm}>{stm}</option>
          ))}
        </select>
        <button
          className="btn btn-outline-primary"
          onClick={handleExportBySTM}
          disabled={!selectedStm}
        >
          📥 Eksportuj
        </button>
      </div>
    </div>
  );
};

export default Reports;
